module.exports = __webpack_public_path__ + "static/img/note.ee8b8f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/note.png
// module id = GlzJ
// module chunks = 1